import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_unavailable_episode_list_message]: 'We’re sorry, an unexpected error occurred with the episode list and we expect to resolve it shortly.{lineBreak}Please try again later.',

}